import React, { Fragment } from "react";
import { Combobox, Dialog, Transition } from "@headlessui/react";
import { Navigate } from "react-router-dom";
import {
  PlusIcon,
  PlusSmIcon as PlusSmIconOutline,
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import moment from "moment";
import Customercreatemodal from "./Customercreatemodal";
import ItemModalcreate from "./ItemModalcreate";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Invoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      opencustomer: false,
      openitem: false,
      invoice_date: "",
      invoice_house_id: "",
      invoice_due_date: "",
      invoice_total: "",
      invoice_payment_made: "",
      invoice_balance_due: "",
      invoice_notes: "",
      invoice_item: [
        {
          name: "",
          item_id: "",
          description: "",
          quantity: 1,
          rate: 0,
        },
      ],
      ItemList: [{ name: "" }],
      houseNumber: [],
      itemLine: [],
      error_list: [],
      query: "",
      queryItem: "",
      selectedPerson: "",
      loader: "",
      overLay: "",
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
    this.handleInput = this.handleInput.bind(this);
    //this.addLine = this.addLine.bind(this);
  }

  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };
  
  componentDidMount() {
    this.getDataForView();
  }


  async getDataForView() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const id = this.props.leadId
      const [
        { data: create },
      ] = await Promise.all([
        axios.get("api/invoice/url/for/create", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } })
      ]);
      this.setState({ houseNumber:create.house_number });
      this.setState({ ItemList:create.invoice_item });
      this.closeLoaderFuncion()

    } catch (error) {
      console.error("Error fetching data: ", error);
      this.enableTryAgain()
    }
  }



  tryAgain = () => {

    this.getDataForView()

  }


  handleInput = (e) => {
    this.setState({
      selectedPerson: e,
    });
    this.setState({ invoice_house_id: e.id });
    console.log("FFF",e)
  };

  handleInputSelectItem = (InvoiceItemIndex) => (e) => {
    this.state.invoice_item[InvoiceItemIndex].name = e.name;
    this.state.invoice_item[InvoiceItemIndex].item_id = e.id;
    this.state.invoice_item[InvoiceItemIndex].rate = e.price;
    this.state.invoice_item[InvoiceItemIndex].quantity = 1;
    // this.state.invoice_item[InvoiceItemIndex].invoiceTax = 0;
    this.calculateTax(InvoiceItemIndex);
  };

  handleInputSelectquantity = (InvoiceItemIndex) => (e) => {
    let qty = e.target.value;
    this.state.invoice_item[InvoiceItemIndex].quantity = qty;
    this.calculateTax(InvoiceItemIndex);
  };

  handleInputAmount = (InvoiceItemIndex) => (e) => {
    let price = e.target.value;
    this.state.invoice_item[InvoiceItemIndex].rate = price;

    this.calculateTax(InvoiceItemIndex);
  };

  handleinvoicetax = (InvoiceItemIndex) => (e) => {
    const taxListIndex = e.target.value;

    if (taxListIndex.length) {
      const Tax = this.state.invoiceTaxlist[taxListIndex];
      this.state.invoice_item[InvoiceItemIndex].gst_igst_common_value =
        Tax.gst_igst_common;
      this.state.invoice_item[InvoiceItemIndex].invoice_tax_id = Tax.id;
      this.state.invoice_item[InvoiceItemIndex].invoice_tax_orgin_percentage =
        Tax.percentage;

      this.calculateTax(InvoiceItemIndex);
    } else {
      this.state.invoice_item[InvoiceItemIndex].invoice_tax_id = 0;
      this.calculateTax(InvoiceItemIndex);
    }
  };

  calculateTax(InvoiceItemIndex) {
    //This is GST and IGST calculation
    if (this.state.invoice_item[InvoiceItemIndex].invoice_tax_id != 0) {
      let qty = this.state.invoice_item[InvoiceItemIndex].quantity;
      let amount = this.state.invoice_item[InvoiceItemIndex].rate;
      let percentageOrgin =
        this.state.invoice_item[InvoiceItemIndex].invoice_tax_orgin_percentage;

      if (
        this.state.invoice_item[InvoiceItemIndex].gst_igst_common_value == 2
      ) {
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentageOrgin).toFixed(2);

        this.state.invoice_item[InvoiceItemIndex].igst_amount = Taxamount;
        this.state.invoice_item[InvoiceItemIndex].igst_percentage =
          percentageOrgin;
      }

      if (
        this.state.invoice_item[InvoiceItemIndex].gst_igst_common_value === 3
      ) {
        let percentage = (percentageOrgin / 2).toFixed(2);
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentage).toFixed(2);

        this.state.invoice_item[InvoiceItemIndex].cgst_amount = Taxamount;
        this.state.invoice_item[InvoiceItemIndex].sgst_amount = Taxamount;
        this.state.invoice_item[InvoiceItemIndex].sgst_percentage = percentage;
        this.state.invoice_item[InvoiceItemIndex].cgst_percentage = percentage;
      }

      if (
        this.state.invoice_item[InvoiceItemIndex].gst_igst_common_value === 1
      ) {
        this.state.invoice_item[InvoiceItemIndex].igst_amount = 0;
        this.state.invoice_item[InvoiceItemIndex].igst_percentage = 0;
        this.state.invoice_item[InvoiceItemIndex].cgst_amount = 0;
        this.state.invoice_item[InvoiceItemIndex].sgst_amount = 0;
        this.state.invoice_item[InvoiceItemIndex].sgst_percentage = 0;
        this.state.invoice_item[InvoiceItemIndex].cgst_percentage = 0;
      }
    }

    if (this.state.invoice_item[InvoiceItemIndex].invoice_tax_id == 0) {
      this.state.invoice_item[InvoiceItemIndex].igst_amount = 0;
      this.state.invoice_item[InvoiceItemIndex].igst_percentage = 0;
      this.state.invoice_item[InvoiceItemIndex].cgst_amount = 0;
      this.state.invoice_item[InvoiceItemIndex].sgst_amount = 0;
      this.state.invoice_item[InvoiceItemIndex].sgst_percentage = 0;
      this.state.invoice_item[InvoiceItemIndex].cgst_percentage = 0;
      this.state.invoice_item[InvoiceItemIndex].gst_igst_common_value = 0;
      this.state.invoice_item[
        InvoiceItemIndex
      ].invoice_tax_orgin_percentage = 0;
    }

    this.state.invoice_item[InvoiceItemIndex].amount =
      this.state.invoice_item[InvoiceItemIndex].quantity *
      this.state.invoice_item[InvoiceItemIndex].rate;

    this.calculateSubTotalTotal();
  }

  calculateSubTotalTotal() {
    let totalTax = 0;
    let subTotal = 0;

    this.state.invoice_item.map((item, sidx) => {
      if (item.gst_igst_common_value === 3) {
        totalTax = totalTax + parseFloat(item.cgst_amount);
        totalTax = totalTax + parseFloat(item.sgst_amount);
      }

      if (item.gst_igst_common_value === 2) {
        totalTax = totalTax + parseFloat(item.igst_amount);
      }

      subTotal = subTotal + item.amount;
    });

    this.setState({ sub_total: subTotal });
    this.setState({ totalTax: totalTax });
    this.setState({ invoice_item: this.state.invoice_item });
  }

  handleInputDescription = (InvoiceItemIndex) => (e) => {
    this.state.invoice_item[InvoiceItemIndex].description = e.target.value;

    this.setState({ invoice_item: this.state.invoice_item });
  };

  handleInputSelecthsn_code = (index) => (e) => {
    const itemsP = this.state.invoice_item.map((item, sidx) => {
      if (index !== sidx) {
        return item;
      }

      return { ...item, hsn_code: e.target.value };
    });

    this.setState({ invoice_item: itemsP });
  };

  handleInputinvoicedetails = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name === "branch_id") {
      this.setLoaderFunction();
      this.setState({ loader: "animate-pulse" });
      const res = axios
        .get("public/api/branch/warehouse/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.closeLoaderFuncion();
          this.setState({ loader: "" });
          this.setState({ warehouseList: res.data.warehouses });
        });
    }

    if (e.target.name === "payment_terms_id") {
      if (e.target.value == 1) {
        this.setState({
          due_date: moment(new Date()).format("YYYY-MM-DD"),
        });
      } else {
        this.setState({
          due_date: "",
        });
      }
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputOne = (e) => {
    this.setState({
      query: e.target.value,
    });
  };

  handleInputtwo = (e) => {
    this.setState({
      queryItem: e.target.value,
    });
  };

  saveItem = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();

    // this.setState({total:this.state.sub_total+this.state.tempV})
    // this.setState({balance_due:this.state.sub_total+this.state.tempV});
    //this.setState({invoice_house_id:this.state.selectedPerson['id_crypt']});
    this.state.invoice_balance_due = this.state.invoice_total;

    this.setState({ invoice_balance_due: this.state.invoice_total });

    this.state.total = this.state.sub_total + this.state.totalTax;
    this.state.balance_due = this.state.sub_total + this.state.totalTax;
    //this.state.invoice_house_id=this.state.selectedPerson['id_crypt'];
    if (this.state.invoice_item.length > 0) {
      if (this.state.balance_due >= 0) {
        var token = localStorage.getItem("token");
        const headers = {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        };

        const res = await axios.post("api/invoice/store", this.state, {
          headers,
        });

        if (res.data.success) {
          this.setState({ showmsg: true });

          setTimeout(
            function () {
              this.closeLoaderFuncion();
              //Start the timer
              this.setState({ redirect: true }); //After 1 second, set render to true
            }.bind(this),
            1000,
          );
        } else {
          this.closeLoaderFuncion();
          this.setState({ error_list: res.data.data });
          //this.setState({ show: true })
        }
      }
    }

    if (this.state.invoice_item.length === 0) {
      this.setState({ showstockmsg: true });
      this.setState({
        stockmsg: "Due Fee cannot be empty",
      });
    }

    if (this.state.balance_due < 0 && this.state.invoice_item.length != 0) {
      this.setState({ showstockmsg: true });
      this.setState({
        stockmsg:
          "Payment alread made. Amount should be greater than Recorded Payment ",
      });
    }
    this.closeLoaderFuncion();
  };

  itemDelete = (InvoiceItemIndex) => (e) => {
    this.state.invoice_item = this.state.invoice_item.filter(
      (s, sidx) => InvoiceItemIndex !== sidx,
    );
    this.calculateSubTotalTotal();

    this.setState({
      invoice_item: this.state.invoice_item,
    });
  };

  addLine = (e) => {
    this.setState({
      invoice_item: this.state.invoice_item.concat([
        {
          name: "",
          item_id: "",
          description: "",
          rate: 0,
        },
      ]),
    });
  };

  addcustomer = (e) => {
    this.setState({ opencustomer: true });
  };

  closecustomer = (e) => {
    this.setState({ opencustomer: false });
  };

  addItem = (e) => {
    this.setState({ openitem: true });
  };
  closeItem = (e) => {
    this.setState({ openitem: false });
  };

  handleInputModal = (e) => {
    this.state.customerList = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/customers", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ customerList: res.data.customers });
          this.setState({ opencustomer: false });
        });
    }
  };

  handleInputModalForItem = async (e) => {
    this.state.itemLine = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/items", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ openitem: false });
          this.setState({ itemLine: res.data.items });
        });
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true }); 
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/admin/Invoicelist"} />;
    }

    const filteredPeople =
      this.state.query === ""
        ? this.state.houseNumber
        : this.state.houseNumber.filter((houseNumber) => {
            return houseNumber.house_number
              .toString()
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });

    const filteredItem =
      this.state.queryItem === ""
        ? this.state.ItemList
        : this.state.ItemList.filter((ItemList) => {
            return ItemList.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html className="h-full bg-gray-100">
        <body className="h-full">
        ```
      */}
        <div>
          <div aria-hidden="true" />

          {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}

          {this.state.main_content_status && (

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* */}

                  {/* */}
                  <h1 className="text-2xl font-semibold text-gray-900">
                    New Due
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.saveItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                {/*start*/}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <Combobox
                                    as="div"
                                    name="invoice_house_id"
                                    value={this.state.selectedPerson}
                                    onChange={this.handleInput}>
                                    <Combobox.Label className="block text-sm font-medium text-gray-700">
                                      <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                        Members
                                      </span>
                                    </Combobox.Label>
                                    <div className="relative mt-1">
                                      <Combobox.Input
                                        className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                        onChange={this.handleInputOne}
                                        displayValue={(cutomer) =>
                                          typeof cutomer.house_number !==
                                            "undefined" &&
                                          cutomer.house_number != null
                                            ? cutomer.house_number
                                            : ""
                                        }
                                      />
                                      <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                        <SelectorIcon
                                          className="h-5 w-5 text-gray-400"
                                          aria-hidden="true"
                                        />
                                      </Combobox.Button>

                                      {filteredPeople.length > 0 && (
                                        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {filteredPeople.map((customer) => (
                                            <Combobox.Option
                                              key={customer.id_crypt}
                                              value={customer}
                                              className={({ active }) =>
                                                classNames(
                                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                                  active
                                                    ? "bg-indigo-600 text-white"
                                                    : "text-gray-900",
                                                )
                                              }
                                            >
                                              {({ active, selected }) => (
                                                <>
                                                  <span
                                                    className={classNames(
                                                      "block truncate",
                                                      selected &&
                                                        "font-semibold",
                                                    )}
                                                  >
                                                    {customer.house_number}
                                                  </span>
                                                  <span
                                                    className={classNames(
                                                      "ml-2 truncate text-gray-500",
                                                      active
                                                        ? "text-indigo-200"
                                                        : "text-gray-500",
                                                    )}
                                                  >
                                                    {"@"}
                                                    {
                                                      customer.house_member
                                                        ?.primary_contact_first_name
                                                    }
                                                  </span>

                                                  {selected && (
                                                    <span
                                                      className={classNames(
                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                        active
                                                          ? "text-white"
                                                          : "text-indigo-600",
                                                      )}
                                                    >
                                                      <CheckIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                      />
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </Combobox.Option>
                                          ))}
                                        </Combobox.Options>
                                      )}
                                    </div>
                                  </Combobox>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.invoice_house_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                  <button
                                    type="button"
                                    onClick={this.addcustomer}
                                    className="mt-5 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    <PlusSmIconOutline
                                      className="h-6 w-6"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="invoice_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Due Create Date
                                    </span>
                                  </label>
                                  <input
                                    type="Date"
                                    name="invoice_date"
                                    id="invoice_date"
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete="invoice_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="invoice_date-error"
                                  >
                                    {this.state.error_list.invoice_date}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="invoice_due_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Due Date
                                    </span>
                                  </label>
                                  <input
                                    type="Date"
                                    name="invoice_due_date"
                                    id="invoice_due_date"
                                    value={this.state.invoice_due_date}
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete="invoice_due_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="invoice_due_date-error"
                                  >
                                    {this.state.error_list.invoice_due_date}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                                  <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0 overflow-x-auto		 ">
                                    <table className="min-w-full divide-y divide-gray-300">
                                      <thead>
                                        <tr>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                              FEE DETAILS
                                            </span>
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            Add
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            DESC
                                          </th>

                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3  text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            RATE
                                          </th>

                                          <th
                                            scope="col"
                                            className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                          >
                                            AMOUNT
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-5 w-5"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                            </svg>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.invoice_item.map(
                                          (Itemsi, index) => (
                                            <tr
                                              key={index}
                                              className="border-b border-gray-200">
                                              <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                                <Combobox
                                                  as="div"
                                                  value={Itemsi}
                                                  onChange={this.handleInputSelectItem(
                                                    index,
                                                  )}>
                                                  <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                                  <div className="relative mt-1">
                                                    <Combobox.Input
                                                      className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                      onChange={
                                                        this.handleInputtwo
                                                      }
                                                      displayValue={(Items) =>
                                                        typeof Items.name !==
                                                          "undefined" &&
                                                        Items.name != null
                                                          ? Items.name
                                                          : ""
                                                      }
                                                    />
                                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                      <SelectorIcon
                                                        className="h-5 w-5 text-gray-400"
                                                        aria-hidden="true"
                                                      />
                                                    </Combobox.Button>

                                                    {filteredItem.length >
                                                      0 && (
                                                      <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                        {filteredItem.map(
                                                          (itemLine) => (
                                                            <Combobox.Option
                                                              key={
                                                                itemLine.id_crypt
                                                              }
                                                              value={itemLine}
                                                              className={({
                                                                active,
                                                              }) =>
                                                                classNames(
                                                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                                                  active
                                                                    ? "bg-indigo-600 text-white"
                                                                    : "text-gray-900",
                                                                )
                                                              }
                                                            >
                                                              {({
                                                                active,
                                                                selected,
                                                              }) => (
                                                                <>
                                                                  <span
                                                                    className={classNames(
                                                                      "block truncate",
                                                                      selected &&
                                                                        "font-semibold",
                                                                    )}
                                                                  >
                                                                    {
                                                                      itemLine.name
                                                                    }
                                                                  </span>

                                                                  {selected && (
                                                                    <span
                                                                      className={classNames(
                                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                        active
                                                                          ? "text-white"
                                                                          : "text-indigo-600",
                                                                      )}
                                                                    >
                                                                      <CheckIcon
                                                                        className="h-5 w-5"
                                                                        aria-hidden="true"
                                                                      />
                                                                    </span>
                                                                  )}
                                                                </>
                                                              )}
                                                            </Combobox.Option>
                                                          ),
                                                        )}
                                                      </Combobox.Options>
                                                    )}
                                                  </div>
                                                </Combobox>
                                              </td>
                                              <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <button
                                                  type="button"
                                                  onClick={this.addItem}
                                                  className="float-right mt-4 inline-flex items-center p-.05 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                >
                                                  <PlusSmIconOutline
                                                    className="h-6 w-6"
                                                    aria-hidden="true"
                                                  />
                                                </button>
                                              </td>
                                              <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="text"
                                                  name="description"
                                                  onChange={this.handleInputDescription(
                                                    index,
                                                  )}
                                                  value={Itemsi.description}
                                                  id="description"
                                                  autoComplete="description"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>

                                              <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="number"
                                                  name="rate"
                                                  onChange={this.handleInputAmount(
                                                    index,
                                                  )}
                                                  value={Itemsi.rate}
                                                  id="rate"
                                                  autoComplete="rate"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>

                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                {Itemsi.amount}
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  onClick={this.itemDelete(
                                                    index,
                                                  )}
                                                  className="h-6 w-6"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  stroke="currentColor"
                                                  strokeWidth={2}
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                  />
                                                </svg>
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td>
                                            <button
                                              type="button"
                                              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                              onClick={this.addLine}
                                            >
                                              <PlusIcon
                                                className="-ml-1 mr-2 h-5 w-5"
                                                aria-hidden="true"
                                              />
                                              Add New Line
                                            </button>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                          >
                                            Subtotal
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                          >
                                            Subtotal
                                          </th>
                                          <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {this.state.sub_total}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                          >
                                            Total
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                          >
                                            Total
                                          </th>
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                            {
                                              (this.state.invoice_total =
                                                this.state.totalTax +
                                                this.state.sub_total)
                                            }
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div className="pt-8">
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="customer_notes"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Customer Notes
                                    </label>
                                    <div className="mt-1">
                                      <textarea
                                        rows={2}
                                        name="customer_notes"
                                        id="customer_notes"
                                        onChange={
                                          this.handleInputinvoicedetails
                                        }
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                        defaultValue={""}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"></div>
                              </div>
                            </div>

                            <div className="px-4 py-3 pt-5">
                              <div className="flex justify-end">
                                <button
                                  type="submit"
                                  className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
          )}
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*add customer */}
        <Transition.Root show={this.state.opencustomer} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closecustomer}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <Customercreatemodal
                        handleInputInvoice={this.handleInputModal}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*add customer*/}

        {/*Item customer*/}
        <Transition.Root show={this.state.openitem} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closeItem}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <ItemModalcreate
                        handleInputInvoiceItem={this.handleInputModalForItem}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*Item customer*/}
      </>
    );
  }
}

export default Invoice;
